<template>
  <section class="p-4">
    <v-tabs fixed-tabs centered v-model="tab" active-class="bg-primary">
      <v-tab
        key="folders"
        active-class="bg-app-primary text-white rounded"
        class="tab-list"
        >Carpetas y Subcarpetas</v-tab
      >
      <v-tab
        class="tab-list"
        active-class="bg-app-primary text-white rounded"
        key="names"
        id="document-names"
        >Nombres de Documentos</v-tab
      >
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item key="projects">
        <maintainer-folders
          :isProject="isProject"
          :isPresale="isPresale"
          @reasignedFolder="reasignedFolder"
          @folderCreatedOrUpdated="$emit('folderCreatedOrUpdated')"
        ></maintainer-folders>
      </v-tab-item>
      <v-tab-item key="names">
        <maintainer-names
          :isProject="isProject"
          :isPresale="isPresale"
          @nameDocumentDeleted="emitNameDocumentDeleted"
          ref="maintainerNames"
        ></maintainer-names>
      </v-tab-item>
    </v-tabs-items>
  </section>
</template>

<script>
import MaintainerFolders from "./folders/foldersMaintainerViewTree.vue";
import MaintainerNames from "./document_names/index.vue";
export default {
  components: {
    MaintainerFolders,
    MaintainerNames,
  },
  props: {
    isProject: {
      type: Boolean,
      default: false,
    },
    isPresale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tab: "folders",
    };
  },
  methods: {
    emitNameDocumentDeleted() {
      this.$emit("updateNameDocumentDeleted");
    },
    reasignedFolder(folder) {
      document.getElementById("document-names").click();
      setTimeout(() => {
        this.$refs.maintainerNames.getDocumentNamesFromFolder(folder);
      }, 500);
    },
  },
};
</script>

<style></style>
